// src/utils/mockData.ts

export const mockHealthCenters = [
  { id: "HC001", name: "Oluko Solidale H/C II", district: "Arua", lat: 2.75, lng: 31.47, status: "Active", battery: "70%" },
  { id: "HC002", name: "Komamboga H/C III", district: "Kampala", lat: 0.34, lng: 32.58, status: "Offline", battery: "30%" },
  { id: "HC003", name: "All Saints H/C III", district: "Kibuku", lat: 1.05, lng: 33.87, status: "Active", battery: "50%" },
  { id: "HC004", name: "Orient Medical Centre", district: "Luwero", lat: 0.85, lng: 32.48, status: "Active", battery: "80%" },
  { id: "HC005", name: "Bombo Military H/C IV", district: "Luwero", lat: 0.84, lng: 32.61, status: "Active", battery: "65%" },
  { id: "HC006", name: "Kasangati H/C IV", district: "Wakiso", lat: 0.42, lng: 32.55, status: "Offline", battery: "40%" },
  { id: "HC007", name: "Mbarara Referral Hospital", district: "Mbarara", lat: -0.61, lng: 30.65, status: "Active", battery: "75%" },
  { id: "HC008", name: "Gulu Regional Hospital", district: "Gulu", lat: 2.77, lng: 32.3, status: "Active", battery: "90%" },
];

export const mockMalariaTrends = [
  { date: "2025-06-01 08:00:00", cases: 2 },
  { date: "2025-06-15 08:00:00", cases: 5 },
  { date: "2025-07-01 08:00:00", cases: 8 },
  { date: "2025-07-15 08:00:00", cases: 10 },
  { date: "2025-08-01 08:00:00", cases: 15 },
  { date: "2025-08-15 08:00:00", cases: 18 },
  { date: "2025-09-01 08:00:00", cases: 21 },
  { date: "2025-09-10 08:00:00", cases: 23 },
];

export const mockDemographics = {
  gender: { male: 520, female: 480 },
  ageDistribution: {
    "0-5 years": 110,
    "6-12 years": 160,
    "13-19 years": 130,
    "19+ years": 600,
  },
};

export const mockRecentActivity = [
  { healthCenter: "Oluko Solidale H/C II", district: "Arua", status: "Positive", species: "P. falciparum", timestamp: "2025-09-10 14:00:00" },
  { healthCenter: "Komamboga H/C III", district: "Kampala", status: "Negative", species: "N/A", timestamp: "2025-09-09 13:50:00" },
  { healthCenter: "All Saints H/C III", district: "Kibuku", status: "Positive", species: "P. vivax", timestamp: "2025-09-08 13:40:00" },
  { healthCenter: "Orient Medical Centre", district: "Luwero", status: "Positive", species: "P. falciparum", timestamp: "2025-09-07 13:30:00" },
  { healthCenter: "Mbarara Referral Hospital", district: "Mbarara", status: "Positive", species: "P. falciparum", timestamp: "2025-09-06 09:10:00" },
  { healthCenter: "Gulu Regional Hospital", district: "Gulu", status: "Negative", species: "N/A", timestamp: "2025-09-05 15:45:00" },
];

export const mockAllTests = [
  {
    deviceIdentifier: "MT001",
    caseIdentifier: "M20250613DB",
    age: 24,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1524 [240-2720]",
    drugResistance: "None detected",
    healthCenter: "Oluko Solidale H/C II",
    location: "Arua",
    timestamp: "2025-06-13 08:00:00",
  },
  {
    deviceIdentifier: "MT002",
    caseIdentifier: "F20250612JE",
    age: 32,
    gender: "Female",
    diagnosisResults: "Negative",
    parasiteSpecies: "N/A",
    parasiteDensity: "0 [0-0]",
    drugResistance: "None detected",
    healthCenter: "Komamboga H/C III",
    location: "Kampala",
    timestamp: "2025-06-12 09:00:00",
  },
  {
    deviceIdentifier: "MT003",
    caseIdentifier: "M20250610RM",
    age: 15,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. vivax",
    parasiteDensity: "980 [140-2100]",
    drugResistance: "Suspected artemisinin partial resistance (K13)",
    healthCenter: "All Saints H/C III",
    location: "Kibuku",
    timestamp: "2025-06-10 10:00:00",
  },
  {
    deviceIdentifier: "MT004",
    caseIdentifier: "F20250609AG",
    age: 28,
    gender: "Female",
    diagnosisResults: "Indeterminate",
    parasiteSpecies: "N/A",
    parasiteDensity: "-",
    drugResistance: "Undetermined",
    healthCenter: "Orient Medical Centre",
    location: "Luwero",
    timestamp: "2025-06-09 11:00:00",
  },
  {
    deviceIdentifier: "MT005",
    caseIdentifier: "M20250608TK",
    age: 37,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1880 [300-3250]",
    drugResistance: "None detected",
    healthCenter: "Bombo Military H/C IV",
    location: "Luwero",
    timestamp: "2025-06-08 12:00:00",
  },
  {
    deviceIdentifier: "MT006",
    caseIdentifier: "F20250607LN",
    age: 41,
    gender: "Female",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "2230 [420-3600]",
    drugResistance: "Suspected artemisinin partial resistance (K13)",
    healthCenter: "Kasangati H/C IV",
    location: "Wakiso",
    timestamp: "2025-06-07 13:00:00",
  },
  {
    deviceIdentifier: "MT007",
    caseIdentifier: "M20250605SW",
    age: 19,
    gender: "Male",
    diagnosisResults: "Negative",
    parasiteSpecies: "N/A",
    parasiteDensity: "0 [0-0]",
    drugResistance: "None detected",
    healthCenter: "Mbarara Referral Hospital",
    location: "Mbarara",
    timestamp: "2025-06-05 14:00:00",
  },
  {
    deviceIdentifier: "MT008",
    caseIdentifier: "F20250604RC",
    age: 22,
    gender: "Female",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. vivax",
    parasiteDensity: "1275 [230-2900]",
    drugResistance: "None detected",
    healthCenter: "Gulu Regional Hospital",
    location: "Gulu",
    timestamp: "2025-06-04 15:00:00",
  },
  {
    deviceIdentifier: "MT009",
    caseIdentifier: "M20250603NP",
    age: 30,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1950 [320-3300]",
    drugResistance: "None detected",
    healthCenter: "Oluko Solidale H/C II",
    location: "Arua",
    timestamp: "2025-06-03 16:00:00",
  },
  {
    deviceIdentifier: "MT010",
    caseIdentifier: "F20250601BL",
    age: 26,
    gender: "Female",
    diagnosisResults: "Negative",
    parasiteSpecies: "N/A",
    parasiteDensity: "0 [0-0]",
    drugResistance: "None detected",
    healthCenter: "Komamboga H/C III",
    location: "Kampala",
    timestamp: "2025-06-01 17:00:00",
  },
  {
    deviceIdentifier: "MT011",
    caseIdentifier: "M20250531JO",
    age: 35,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1650 [250-2900]",
    drugResistance: "None detected",
    healthCenter: "All Saints H/C III",
    location: "Kibuku",
    timestamp: "2025-06-15 08:30:00",
  },
  {
    deviceIdentifier: "MT012",
    caseIdentifier: "F20250530ZA",
    age: 40,
    gender: "Female",
    diagnosisResults: "Indeterminate",
    parasiteSpecies: "N/A",
    parasiteDensity: "-",
    drugResistance: "Undetermined",
    healthCenter: "Orient Medical Centre",
    location: "Luwero",
    timestamp: "2025-06-16 09:15:00",
  },
  {
    deviceIdentifier: "MT013",
    caseIdentifier: "M20250529BR",
    age: 29,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. vivax",
    parasiteDensity: "1450 [220-3000]",
    drugResistance: "None detected",
    healthCenter: "Bombo Military H/C IV",
    location: "Luwero",
    timestamp: "2025-06-18 10:00:00",
  },
  {
    deviceIdentifier: "MT014",
    caseIdentifier: "F20250528PO",
    age: 18,
    gender: "Female",
    diagnosisResults: "Negative",
    parasiteSpecies: "N/A",
    parasiteDensity: "0 [0-0]",
    drugResistance: "None detected",
    healthCenter: "Kasangati H/C IV",
    location: "Wakiso",
    timestamp: "2025-06-19 10:30:00",
  },
  {
    deviceIdentifier: "MT015",
    caseIdentifier: "M20250527AL",
    age: 21,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1800 [280-3120]",
    drugResistance: "None detected",
    healthCenter: "Mbarara Referral Hospital",
    location: "Mbarara",
    timestamp: "2025-06-20 11:00:00",
  },
  {
    deviceIdentifier: "MT016",
    caseIdentifier: "F20250525SE",
    age: 30,
    gender: "Female",
    diagnosisResults: "Negative",
    parasiteSpecies: "N/A",
    parasiteDensity: "0 [0-0]",
    drugResistance: "None detected",
    healthCenter: "Gulu Regional Hospital",
    location: "Gulu",
    timestamp: "2025-06-21 11:30:00",
  },
  {
    deviceIdentifier: "MT017",
    caseIdentifier: "M20250524NI",
    age: 38,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. vivax",
    parasiteDensity: "1320 [210-2780]",
    drugResistance: "Suspected artemisinin partial resistance (K13)",
    healthCenter: "Oluko Solidale H/C II",
    location: "Arua",
    timestamp: "2025-06-22 12:00:00",
  },
  {
    deviceIdentifier: "MT018",
    caseIdentifier: "F20250523CL",
    age: 44,
    gender: "Female",
    diagnosisResults: "Indeterminate",
    parasiteSpecies: "N/A",
    parasiteDensity: "-",
    drugResistance: "Undetermined",
    healthCenter: "Komamboga H/C III",
    location: "Kampala",
    timestamp: "2025-06-23 13:00:00",
  },
  {
    deviceIdentifier: "MT019",
    caseIdentifier: "M20250522TE",
    age: 11,
    gender: "Male",
    diagnosisResults: "Negative",
    parasiteSpecies: "N/A",
    parasiteDensity: "0 [0-0]",
    drugResistance: "None detected",
    healthCenter: "All Saints H/C III",
    location: "Kibuku",
    timestamp: "2025-06-24 13:30:00",
  },
  {
    deviceIdentifier: "MT020",
    caseIdentifier: "F20250521AB",
    age: 19,
    gender: "Female",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "2100 [320-3520]",
    drugResistance: "None detected",
    healthCenter: "Orient Medical Centre",
    location: "Luwero",
    timestamp: "2025-06-25 14:00:00",
  },
  {
    deviceIdentifier: "MT021",
    caseIdentifier: "M20250520GC",
    age: 42,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1780 [250-3000]",
    drugResistance: "None detected",
    healthCenter: "Bombo Military H/C IV",
    location: "Luwero",
    timestamp: "2025-06-26 15:00:00",
  },
  {
    deviceIdentifier: "MT022",
    caseIdentifier: "F20250519VB",
    age: 27,
    gender: "Female",
    diagnosisResults: "Negative",
    parasiteSpecies: "N/A",
    parasiteDensity: "0 [0-0]",
    drugResistance: "None detected",
    healthCenter: "Kasangati H/C IV",
    location: "Wakiso",
    timestamp: "2025-06-27 15:30:00",
  },
  {
    deviceIdentifier: "MT023",
    caseIdentifier: "M20250518OS",
    age: 23,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "2010 [330–3420]",
    drugResistance: "None detected",
    healthCenter: "Oluko Solidale H/C II",
    location: "Arua",
    timestamp: "2025-06-28 16:00:00",
  },
  {
    deviceIdentifier: "MT024",
    caseIdentifier: "F20250517MW",
    age: 36,
    gender: "Female",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. ovale",
    parasiteDensity: "980 [150–1900]",
    drugResistance: "None detected",
    healthCenter: "Komamboga H/C III",
    location: "Kampala",
    timestamp: "2025-06-29 17:00:00",
  },
  {
    deviceIdentifier: "MT025",
    caseIdentifier: "M20250516JR",
    age: 22,
    gender: "Male",
    diagnosisResults: "Indeterminate",
    parasiteSpecies: "N/A",
    parasiteDensity: "-",
    drugResistance: "Undetermined",
    healthCenter: "All Saints H/C III",
    location: "Kibuku",
    timestamp: "2025-06-30 17:30:00",
  },
  {
    deviceIdentifier: "MT026",
    caseIdentifier: "F20250515LP",
    age: 33,
    gender: "Female",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1900 [320-3200]",
    drugResistance: "None detected",
    healthCenter: "Orient Medical Centre",
    location: "Luwero",
    timestamp: "2025-07-01 08:00:00",
  },
  {
    deviceIdentifier: "MT027",
    caseIdentifier: "M20250514UR",
    age: 17,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. vivax",
    parasiteDensity: "1100 [200-2500]",
    drugResistance: "Suspected artemisinin partial resistance (K13)",
    healthCenter: "Bombo Military H/C IV",
    location: "Luwero",
    timestamp: "2025-07-02 08:30:00",
  },
  {
    deviceIdentifier: "MT028",
    caseIdentifier: "F20250513AK",
    age: 39,
    gender: "Female",
    diagnosisResults: "Negative",
    parasiteSpecies: "N/A",
    parasiteDensity: "0 [0-0]",
    drugResistance: "None detected",
    healthCenter: "Kasangati H/C IV",
    location: "Wakiso",
    timestamp: "2025-07-03 09:00:00",
  },
  {
    deviceIdentifier: "MT029",
    caseIdentifier: "M20250512ES",
    age: 20,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1500 [220-2700]",
    drugResistance: "None detected",
    healthCenter: "Oluko Solidale H/C II",
    location: "Arua",
    timestamp: "2025-07-04 09:30:00",
  },
  {
    deviceIdentifier: "MT030",
    caseIdentifier: "F20250511CJ",
    age: 25,
    gender: "Female",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1700 [260-3050]",
    drugResistance: "None detected",
    healthCenter: "Komamboga H/C III",
    location: "Kampala",
    timestamp: "2025-07-05 10:00:00",
  },
  {
    deviceIdentifier: "MT031",
    caseIdentifier: "M20250510KR",
    age: 14,
    gender: "Male",
    diagnosisResults: "Negative",
    parasiteSpecies: "N/A",
    parasiteDensity: "0 [0-0]",
    drugResistance: "None detected",
    healthCenter: "All Saints H/C III",
    location: "Kibuku",
    timestamp: "2025-07-06 10:30:00",
  },
  {
    deviceIdentifier: "MT032",
    caseIdentifier: "F20250509TP",
    age: 29,
    gender: "Female",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. vivax",
    parasiteDensity: "1250 [230-2850]",
    drugResistance: "None detected",
    healthCenter: "Orient Medical Centre",
    location: "Luwero",
    timestamp: "2025-07-07 11:00:00",
  },
  {
    deviceIdentifier: "MT033",
    caseIdentifier: "M20250508EG",
    age: 16,
    gender: "Male",
    diagnosisResults: "Positive",
    parasiteSpecies: "P. falciparum",
    parasiteDensity: "1850 [330-3150]",
    drugResistance: "None detected",
    healthCenter: "Bombo Military H/C IV",
    location: "Luwero",
    timestamp: "2025-07-08 11:30:00",
  },
];
export const mockDevices = [
  { id: "MT001", connectivityStatus: "Active", batteryStatus: "70%", healthCenter: "Oluko Solidale H/C II", location: "Arua" },
  { id: "MT002", connectivityStatus: "Offline", batteryStatus: "30%", healthCenter: "Komamboga H/C III", location: "Kampala" },
  { id: "MT003", connectivityStatus: "Active", batteryStatus: "50%", healthCenter: "All Saints H/C III", location: "Kibuku" },
  { id: "MT004", connectivityStatus: "Active", batteryStatus: "80%", healthCenter: "Orient Medical Centre", location: "Luwero" },
  { id: "MT005", connectivityStatus: "Active", batteryStatus: "65%", healthCenter: "Bombo Military H/C IV", location: "Luwero" },
  { id: "MT006", connectivityStatus: "Offline", batteryStatus: "40%", healthCenter: "Kasangati H/C IV", location: "Wakiso" },
  { id: "MT007", connectivityStatus: "Active", batteryStatus: "75%", healthCenter: "Mbarara Referral Hospital", location: "Mbarara" },
  { id: "MT008", connectivityStatus: "Active", batteryStatus: "90%", healthCenter: "Gulu Regional Hospital", location: "Gulu" },
];

export const mockPositiveCases = mockAllTests
  .filter((t) => t.diagnosisResults === "Positive")
  .slice(0, 50)
  .map((t, idx) => ({
    id: `PC${String(idx + 1).padStart(3, "0")}`,
    age: t.age,
    gender: t.gender,
    species: t.parasiteSpecies,
    parasiteDensity:
      t.age % 3 === 0 ? "High" : t.age % 2 === 0 ? "Medium" : "Low",
    drugResistance: t.age % 4 === 0 ? "Yes" : "No",
    location: t.location,
    timestamp: t.timestamp,
  }));
